var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { BracketsTableContentValue } from '../BracketsTable';
import { Icon } from '../Icon';
import { Text } from '../Text';
export var ActualValue = styled(BracketsTableContentValue).attrs(function (_a) {
  var theme = _a.theme,
    isDiscounted = _a.isDiscounted;
  return {
    color: isDiscounted ? theme.tokens.interface.feedback.positive.strong : theme.tokens.text.title.regular
  };
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
ActualValue.displayName = 'ActualValue';
export var OriginalValue = styled(Text).attrs({
  el: 'span',
  styleName: 'bodyRegular',
  variant: 'tertiary'
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: line-through;\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  text-decoration: line-through;\n  font-weight: ", ";\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.light;
});
OriginalValue.displayName = 'OriginalValue';
export var IconCheck = styled(Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: auto 0;\n"], ["\n  margin: auto 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3;